import React, { useEffect, useState} from 'react'
import {Dialog, DialogTitle, DialogContent, Select, MenuItem, InputLabel, Button, Skeleton} from '@mui/material'
import { itemServices } from 'src/services/reservation/item/item.service'
import { useTranslate, useRecordContext, useNotify} from 'react-admin'
import SaveIcon from '@mui/icons-material/Save'
import LoadingButton from '@mui/lab/LoadingButton'

export const ChangeStatusDialog = ({open, setOpen, refresh}) => {
    const notify = useNotify()
    const translate = useTranslate()
    const item = useRecordContext()
    const [isLoading, setIsLoading] = useState(false)
    const [loadingOptions, setLoadingOptions] = useState(false)
    const [statusOptions, setStatusOptions] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(item.status)

    const getOptions = async () =>{
        setLoadingOptions(true)
        if(item.product?.ref_table_detail){
            let itemType = item.product?.ref_table_detail
            if(item.product?.ref_table_detail === 'train_detail_segment' || item.product?.ref_table_detail === 'train_detail_passes'){
                itemType = 'train_detail'
            }
            await itemServices.getItemStatusOptions(itemType.replace('_', '-')).then(res=>{
                setStatusOptions(res)
            }).finally(()=>{
                setLoadingOptions(false)
            })
        }  
    }
    useEffect(()=>{
        getOptions()
    },[])

    const onSubmit = async() =>{
        setIsLoading(true)
        await itemServices.update_status_item(selectedStatus, item.hash_).then(()=>{
            setOpen(false)
            refresh()
            notify('ra.message.change_status', {
                type:'success',
                messageArgs:{status:translate(`ra.status.${selectedStatus}`)}
            })
        }).catch(()=>{
            notify('ra.message.update_status_error', {type:'error'})
        }).finally(()=>{
            setIsLoading(false)
        })
    }
  return (
    <div>
        <Dialog
            open = {open}
            onClose={()=>setOpen(false)}
            fullWidth
        >
            <DialogTitle>
                {translate('ra.title.update_status')}
            </DialogTitle>
            <DialogContent>
                <InputLabel id='status'>{translate('ra.field.status')}</InputLabel>
                <Select
                    id='status'
                    fullWidth
                    defaultValue={item.status}
                    size='small'
                    onChange={value=>setSelectedStatus(value.target.value)}
                    renderValue={value=>
                        translate(`ra.status.${value}`)
                    }
                >   
                    {
                        loadingOptions ? <Skeleton variant='rectangular' width={'100%'} height={40} />
                        :
                        statusOptions.map(option=>(
                            <MenuItem value={option} key={option}>
                                {translate(`ra.status.${option}`)}
                            </MenuItem>
                        ))
                    }
                </Select>
            </DialogContent>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', margin:'15px'}}>
                <LoadingButton
                    loading={isLoading}
                    variant='contained'
                    startIcon={<SaveIcon />}
                    onClick={onSubmit}
                >
                    {translate('ra.action.save')}
                </LoadingButton>
                <Button onClick={()=>setOpen(false)} variant='outlined' color='error'>
                    {translate('ra.action.cancel')}
                </Button>
            </div>
        </Dialog>
    </div>
  )
}
